import { ThumbsDown, ThumbsUp } from '@hungryroot/icons';
import { Paragraph } from '@hungryroot/ramen';
import {
  ApiV1LikeDislikeEnum as LikeDislikeEnum,
  type LikeDislikeRatings,
} from '../BinaryRatings/api';
import styles from './LikedDislikedIndicator.module.css';

interface Props {
  testid?: string;
  rating: LikeDislikeRatings;
  className?: string;
}

export function LikedDislikedIndicator(props: Props) {
  const { testid, rating, className } = props;

  function renderIndicator() {
    if (rating === LikeDislikeEnum.Liked) {
      return (
        <span
          data-testid={`${testid}-liked`}
          className={styles['indicator-wrapper-liked']}
        >
          <ThumbsUp />
          <Paragraph variant="caption">Liked</Paragraph>
        </span>
      );
    }

    if (rating === LikeDislikeEnum.Disliked) {
      return (
        <span
          data-testid={`${testid}-disliked`}
          className={styles['indicator-wrapper-disliked']}
        >
          <ThumbsDown />
          <Paragraph variant="caption">Disliked</Paragraph>
        </span>
      );
    }
  }

  if (rating === LikeDislikeEnum.NoRating) return null;

  return (
    <div className={className} data-testid={testid}>
      {renderIndicator()}
    </div>
  );
}
